import { FC, useEffect } from "react"
import { GamePhoneSideDecorationImg, GameStonesHorizontalImg } from "@/assets"
import { useGameConnectionOverlay } from "@/hooks/useGameConnectionOverlay"
import { useGameplayReconciler } from "@/hooks/useGameplayReconciler"
import { useModals } from "@/modals"
import { GameProvider, useGame } from "@/providers/GameProvider"
import { useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import { ContentContainer } from "@/ui/ContentContainer"
import { GameConnectionOverlay } from "@/ui/GameConnectionOverlay"
import styles from "./Game.module.scss"
import {
  ChangeTurnPopup,
  GameDesk,
  GameMenu,
  GameSideOpponent,
  GameSidePlayer,
  GameTopProgress
} from "./ui"
import { GameMatchLogs } from "./ui/GameMatchLogs"

export const GameComponent: FC = () => {
  const { openModal, closeAllModals } = useModals()

  const isPhoneDevice = useAppSelector(AppSelectors.selectIsPhoneDevice())
  const isDesktop = useAppSelector(AppSelectors.selectIsDesktop())

  const {
    matchSession,
    player,
    opponent,
    isGameStateFetching,
    isPlayerCardsLoading,
    isMyMatch
  } = useGame()

  useEffect(() => {
    if (!isMyMatch) return

    if (
      matchSession?.status === "FINISHED" ||
      player?.progress === 0 ||
      opponent?.progress === 0
    ) {
      closeAllModals()
      openModal("finishMatch")
    }
  }, [matchSession, player, opponent, isMyMatch])

  if (isGameStateFetching || isPlayerCardsLoading) return

  return (
    <ContentContainer>
      <div className={styles.Game}>
        <ChangeTurnPopup />
        <GameTopProgress />
        <div className={styles.Game_content}>
          <div className={styles.Game_stones}>
            {isPhoneDevice && (
              <>
                <div
                  className={styles.Game_stones_left}
                  style={{
                    backgroundImage: `url(${GamePhoneSideDecorationImg})`
                  }}
                />
                <div
                  className={styles.Game_stones_right}
                  style={{
                    backgroundImage: `url(${GamePhoneSideDecorationImg})`
                  }}
                />
              </>
            )}
            <div
              className={styles.Game_stones_top}
              style={{ backgroundImage: `url(${GameStonesHorizontalImg})` }}
            />
            <div
              className={styles.Game_stones_bottom}
              style={{ backgroundImage: `url(${GameStonesHorizontalImg})` }}
            />
          </div>
          <GameSidePlayer />
          <GameDesk />
          <GameSideOpponent />
        </div>
        {isDesktop && <GameMatchLogs />}
        <GameMenu />
      </div>
    </ContentContainer>
  )
}

export const Game: FC = () => {
  useGameConnectionOverlay()
  useGameplayReconciler()

  return (
    <>
      <GameProvider>
        <GameComponent />
      </GameProvider>
      <GameConnectionOverlay />
    </>
  )
}
